<template>
  <b-card
    no-body
    v-draggable
    ref="seobility_subcard"
    id="seobility-subcard"
  >
    <!-- Header -->
    <b-card-header
      style="color: lightgrey; height: 25px; cursor: move"
      class="pl-2 pb-0 pt-0"
      header-tag="div"
      header-bg-variant="dark"
    >
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          {{headerLine}}
          <span v-if="isCompetitor"
            >-
            {{ $t("Webportal.CX.Dashboard.Exploration.Competitor") }}
          </span>
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon
            class="mx-1 clickable"
            :icon="['far', 'times']"
            @click="close()"
          />
        </b-col>
      </b-row>
    </b-card-header>

    <!-- Content -->
    <div v-if="isLoading" :class="{ spinner: isLoading }" style="height:200px"></div>
    <b-card-text
      v-else-if="SeobilityData != null" 
      class="pl-3 pr-3" 
      style="overflow: auto"
    >
      <!-- Top menu -->
      <b-row>
        <b-col cols="11" class="subcard-title">
          {{ headLine || SeobilityData.Name }}
        </b-col>
      </b-row>

      <b-button-group>
        <CompetititorDropbox
          v-if="SeobilityData.Competitors && SeobilityData.Competitors.length > 0"
          :competitorList="SeobilityData.Competitors"
          @openCompetitor="openCompetitor"
        />
        <b-button :disabled="isDownloading" @click="downloadSeoReport()" class="d-inline-block">
          <font-awesome-icon icon="file-pdf" /> {{ $t("Webportal.Download") }}
        </b-button>
        <b-button target="_blank" rel="noopener" v-if="seobilityURL || (SeobilityData.Seobility && SeobilityData.Seobility.URL)" :href="seobilityURL || SeobilityData.Seobility.URL">
          <font-awesome-icon
            style="height: 15px; width: 15px"
            :icon="['far', 'external-link']"
          />
          {{ $t("Webportal.CX.Explorations.Seobility.SeobilityLink")}}
        </b-button>
      </b-button-group>

      <template v-if="!isCompetitor">
        <ScoresChart :Scores="SeobilityData.OverallScores" :Width="650" v-if="SeobilityData.OverallScores"/>
        <hr>

        <table class="table mb-0" v-if="SeobilityData.Ratings">
          <tr>
            <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.History") }}</th>
            <th class="border-top-0" colspan="2">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
          </tr>
          <RatingTableRow
            v-for="item in SeobilityData.Ratings"
            :key="item.title"
            :Title="item.RatingTypeName"
            :Ratings="item.RatingTypeResults" />
        </table>
      </template>
      <template v-else>
        <table class="table">
          <thead>
            <tr>
              <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
              <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
            </tr>
          </thead>
          <CompetitorRatingTableRow :rating="SeobilityData.Ratings.find(r => r.Name == 'OverallScore')" />
          <template v-for="(rating) in SeobilityData.Ratings.filter(r => r.Name != 'OverallScore')">
            <CompetitorRatingTableRow :rating="rating" :key="rating.Name"/>
          </template>
        </table>
      </template>
      
    </b-card-text>
  </b-card>
</template>

<script>
import { DxGeometry, DxBarGauge, DxSize } from "devextreme-vue/bar-gauge";

import DownloadFileMixin from '@/mixins/DownloadFileMixin'
import DashboardService from "@/services/DashboardService";

import Accordion from "../Accordion";
import CompetititorDropbox from "./CompetitorDropbox";

import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";
import TrendIcon from "@/components/Shared/TrendIcon";
import ScoresChart from "@/components/CX/ExplorationCard/ScoresChart";
import RatingTableRow from "@/components/CX/ExplorationCard/RatingTableRow";
import CompetitorRatingTableRow from "@/components/CX/CompetitorRatingTableRow";

export default {
  name: "SeobilityPopup",

  components: {
    RatingTableRow,
    CompetitorRatingTableRow,
    AccomplishmentIcon,
    TrendIcon,
    ScoresChart,

    DxGeometry,
    DxBarGauge,
    DxSize,

    Accordion,
    CompetititorDropbox,
  },

  mixins: [ DownloadFileMixin ],

  props: {
    seobilityData: {
      type: Object,
      default: () => {},
    },
    seobilityURL: String,
    headerLine: {
      type: String,
      default: "seobility"
    },
    headLine: String,
    isCompetitor: Boolean,
    competitorId: Number,
    clientLocationId: Number
  },

  data() {
    return {
      SeobilityData: null,
      isDownloading: false,
      isLoading: true
    };
  },

  watch: {
    seobilityData: function() {
      this.refresh();
    },
    '$i18n.locale': function() {
      this.refresh();
    }
  },

  computed: {
    ApiID: function () {
      return (
        this.SeobilityData?.ApiID ||
        this.SeobilityData?.Seobility?.ApiID
      );
    },
    Ratings: function () {
      return (
        this.SeobilityData?.Ratings ||
        this.SeobilityData?.Seobility?.Ratings ||
        []
      );
    },
    OverallScore: function () {
      return (
        this.SeobilityData?.Threshold?.Value ||
        this.SeobilityData?.Seobility?.RatingsByName?.OverallScore?.Value ||
        0
      );
    },
  },
  created: function() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  mounted: function () {
    this.refresh();
  },

  methods: {
    refresh() {
      if (this.isCompetitor) {
        this.getCompetitor(this.competitorId)
          .then((response) => {
            this.SeobilityData = response.data;

            if (this.SeobilityData.Seobility) {
              this.SeobilityData.Seobility.RatingsByName = _.keyBy(
                this.SeobilityData.Seobility.Ratings,
                "Name"
              );

              this.setSeoData();
            }
          })
          .catch((error) => {
            console.warn(error);
          })
          .finally(() =>{
            this.isLoading = false;
          });
      } else {
        this.SeobilityData = { ...this.seobilityData };
        this.setSeoData();
        // use setTimeout() to await next event cycle/finished building
        window.setTimeout(() => {this.isLoading = false}, 0);
      }
    },
    openCompetitor(id) {
      this.$emit("open-competitor", id);
    },

    getCompetitor(competitorId) {
      return DashboardService.getCompetitor(competitorId, { seobility: true });
    },

    setSeoData() {
      if (!this.Ratings) return;

      // Extract GroupRatings from dynamic list, store rest and result
      let parts = _.partition(this.Ratings, (r) =>
        [
          "MetaInformation",
          "PageQuality",
          "PageStructure",
          "LinkStructure",
          "Server",
          "ExternalFactors",
        ].includes(r.Name)
      );

      // [0] = true, [1] = false, dont sort GroupRatings to perserve order
      // Non GroupRatings are sorted from bad to good in SP
      this.SeobilityData.GroupRatings = parts[0];
      this.SeobilityData.Ratings = parts[1];
    },

    downloadSeoReport() {
      this.isDownloading = true;
      DashboardService.getSeoReport(
        this.isCompetitor ? this.competitorId : this.clientLocationId,
        this.ApiID,
        this.isCompetitor
      )
      .then((response) => {
        this.downloadFile(response);
        this.isExporting = false;
      })
      .catch((_) => {
        this.$bvToast.toast(
          this.$t("Webportal.CX.Margin.CheckReportErrorMessage"),
          {
            title: this.$t("Webportal.CX.Margin.CheckReportErrorTitle"),
            autoHideDelay: 5000,
            variant: "danger",
            noCloseButton: true,
          }
        );
      })
      .finally((_) => {
        this.isDownloading = false;
      });
    },
    close() {
      window.removeEventListener('keyup', this.handleKeyUp);
      this.$emit('close');
    },
    handleKeyUp(event) {
      if (event.key == 'Escape') {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.subcard-title {
  font-size: 1.5rem;
}
#seobility-subcard {
  position: fixed !important;
}
td span {
  text-align: right;
  display: inline-block;
  min-width: 4rem;
}
</style>
